<div class="component-wrapper">
  <div class="container">
    @for (obj of value.getKeys(); track obj) {
      <span>
        <ng-container *ngTemplateOutlet="rowContentTmpl; context: {$implicit: obj}"></ng-container>
      </span>
    }
    <ng-container *ngTemplateOutlet="emptyRowContentTmpl"></ng-container>
  </div>
</div>
